<template>
    <v-card-text
        class="card-info-text-group"
        :class="{ 'small-bottom-margin': smallBottomMargin }"
    >
        <span class="card-info-title">When entering the PIN :</span><br />
        <span class="card-info-text">
            <span>1. Do not include spaces.</span><br />
            <span
                >2. Do not enter the letters "i" or "o" (not used for
                PINs).</span
            ><br />
            <span>3. Do use the numerals 1 and 0 (used for PINs).</span><br />
            <div
                class="extra-message-wrapper"
                v-for="(message, i) in extraPinMessages"
                :key="i"
            >
                <span class="extra-message">* {{ message }}</span>
            </div>
        </span>
    </v-card-text>
</template>

<script>
export default {
    name: 'pin-info',
    props: {
        extraPinMessages: {
            type: Array,
            default: () => [],
        },
        smallBottomMargin: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.card-info-text-group {
    width: 300px;
    padding: 0 0 42px 0;
    &.small-bottom-margin {
        padding-bottom: 27px;
    }
    font-size: 14px;
    line-height: 21px;
    @include break('xs') {
        color: #212843;
    }
    @include break('sm') {
        padding-bottom: 192px;
        color: #212843;
        &.small-bottom-margin {
            padding-bottom: 42px;
        }
        width: 500px;
    }
    @include break('md') {
        width: 380px;
        padding-top: 0;
        padding-bottom: 18px;
        font-size: 11px;
        line-height: 1.64;
    }
    text-align: left;
    color: rgba(255, 255, 255, 0.7);
    .card-info-title {
        color: #212843;
        line-height: 18px;
    }
    .card-info-text {
        @include break('md') {
            color: grey;
            line-height: 0.8;
        }
        .extra-message {
            color: #e92852;
            line-height: 18px;
        }
        .extra-message-wrapper {
            @include break('md') {
                max-width: 268px;
            }
        }
    }
}
</style>
